import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import { IconEdit, IconFilter, IconTrash } from "@tabler/icons-react";
import {
  deleteJobOpenings,
  getJobOpenings,
  getDepartments,
  getProfitCenter,
  insertJobOpenings,
} from "../../services/dataService";
import { data } from "jquery";
import Loading from "../../components/common/Loading";
import CustomAlert from "../../components/common/CustomAlert";
import toast from "react-hot-toast";
import FilterComponent from "../pages/FilterComponent";
import { getSecureItem } from "../../services/SecureStorage";

export default function JobOpening() {
  const UID = getSecureItem("userId");
  const [uFetch, setUfetch] = useState({
    UserId: UID,
  });
  const [addJobOpeningModal, setAddJobOpeningModal] = useState(false);
  const [editJobOpeningModal, setEditJobOpeningModal] = useState(false);
  const [jobOpenings, setJobOpenings] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [profitCenters, setProfitCenters] = useState([]);
  const [department, setDepartment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilterVisible, setIsFilterVisible] = useState(false);

  const [error, setError] = useState();
  const [deleteJobOpeningsTypeId, setDeleteJobOpeningsTypeId] = useState(null); // Correct naming convention
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [resetPaginationToggle, setResetPaginationToggle] =React.useState(false);
  const [jobOpeningData, setJobOpeningData] = useState({
    Id: "",
    PostName: "",
    PayScale: "",
    AgeLimit: "",
    UserId: UID,
  });

  const openAddJobOpeningModal = () => {
    setJobOpeningData({
      Id: "",
      PostName: "",
      PayScale: "",
      AgeLimit: "",
      UserId: UID,
    });
    setAddJobOpeningModal(!addJobOpeningModal);
  };

  const openEditJobOpeningModal = (data) => {
    console.log("data", data);
    // profitcenter id name
    const ProfitCenterName = profitCenters.find((item) => {
      console.log(profitCenters, "crProfit");

      if (item.Id == data?.ProfitCenterId) {
        return item?.Name;
      }
    });
    console.log("ProfitCenterName", ProfitCenterName);

    // departement ID
    const DepartmentName = department.find((item) => {
      console.log(department, "department");

      if (item.Id == data?.DepartmentId) {
        return item?.Name;
      }
    });
    console.log("DepartmentName", DepartmentName);

    setEditJobOpeningModal(!editJobOpeningModal);
    setJobOpeningData({
      ...data,
      ProfitCenterId: data?.ProfitCenterId,
      DepartmentId: data?.DepartmentId,
      ProfitCenter: ProfitCenterName?.Name,
      Department: DepartmentName?.Name,
      UserId: UID || "",
    });
  };

  const fetchJobOpenings = async () => {
    try {
      const data = await getJobOpenings(UID);
      console.log(data.data.data, "Fetched data");
      setJobOpenings(data.data.data);
      setIsFilterVisible(false)
    } catch (error) {
      console.error("Error fetching jobOpenings", error);
    }
    setLoading(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setJobOpeningData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await insertJobOpenings(jobOpeningData);
      console.log('=========================>>>>',response);
      if (response?.status === 200) {
        toast.success(response.data.message);
        fetchJobOpenings(); // Refresh the provident funds list
        openAddJobOpeningModal()
      }else{
        toast.warn(response?.data?.message || "Something went wrong.");

      }
    } catch (error) {
      console.error("error", error);
      if (error?.response?.data?.details) {
        console.log(error,"ckeck");
        toast.error(error.response.data.details || "An error occurred.");
      } else {
        toast.error("An unexpected error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };
  
  const handleEdit = async (e) => {
    e.preventDefault()
    setLoading(true)
    try {
      const response = await insertJobOpenings(jobOpeningData);
      if (response?.status === 201) {
        console.log("Job Opening updated successfully:", response);
        toast.success("Job Opening Updated successfully!");
        fetchJobOpenings()
        openEditJobOpeningModal()
      } else {
        // Display warning toast if no response
        toast.warning("No response received!");
      }
    } catch (error) {
      console.error("Error adding jobOpening:", error);
  
      // Display error toast
      toast.error("Error editing job opening. Please try again!");
    } finally {
     setLoading(false)
    }
  };

  const handleDelete = async (jobOpeningId) => {
    const removeData = { Id: jobOpeningId, TableName: "JobOpening" };
    try {
      const res = await deleteJobOpenings(removeData, UID);
      console.log(res,'============================////');
      if (res) {
        if (res.data.message === "Deleted Successfully") {
          toast.success("Job Opening deleted successfully");
          fetchJobOpenings(); // Refresh the list
        } else {
          toast.error("Unexpected response from the server.");
        }
      } else {
        toast.error("Error deleting Job Opening ");
      }
    }  catch (error) {
      if (error.response && error.response.status === 409) {
        const errorMessage =
          error.response.data?.message ||
          "Conflict occurred while deleting Job oprning.";
        toast.error('Job oprning already using cannot delete');
      } else {
        console.error("Error removing Job oprning", error);
        toast.error("Error deleting Job oprning. Please try again.");
      }
    }
  };

  const handleBlur = () => {
    // Check if the input is numeric
    if (!/^\d*$/.test(jobOpeningData.AgeLimit)) {
      setError("Please enter a valid Age Limit.");
    } else {
      setError(""); // Clear the error if input is valid
    }
  };

  const columnsFilter = [
    {
      name: "Sl No",
      // Instead of selector, use cell
      cell: (row, index) => {
        // Access the current page and rows per page from the component props
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Post Name",
      selector: (row) => row.PostName,
      sortable: true,
    },

    {
      name: "Age Limit",
      selector: (row) => row.AgeLimit,
      sortable: true,
    },
    {
      name: "Payscale",
      selector: (row) => row.PayScale,
      sortable: true,
    },

    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="bg-sky rounded-[4px] px-10 py-[8px]"
            onClick={() => openEditJobOpeningModal(row)}
          >
            <IconEdit className="text-white w-[18px] h-[18px]" />
          </button>
          <button
            className="bg-danger rounded-[4px] px-10 py-[8px]"
            onClick={() => openModal(row.Id)}
          >
            <IconTrash className="text-white w-[18px] h-[18px]" />
          </button>
        </div>
      ),
    },
  ];

  const openModal = (jobOpeningId) => {
    setDeleteJobOpeningsTypeId(jobOpeningId);
    setIsModalOpen(true);
  };

  // Close the modal and reset the state
  const closeModal = () => {
    setIsModalOpen(false);
    setDeleteJobOpeningsTypeId(null);
  };

  // Trigger the delete operation and close the modal
  const confirmDelete = () => {
    if (deleteJobOpeningsTypeId) {
      handleDelete(deleteJobOpeningsTypeId); // Ensure handleDelete is defined correctly
    }
    closeModal();
  };

  const clearData = () => {
    setJobOpeningData({
      Id: "",
    PostName: "",
    PayScale: "",
    AgeLimit: "",
    UserId: UID,
    })
  }

  const clearDataForEdit = () => {
    setJobOpeningData((ref) => ({
      ...ref, // Spread the previous state
      PostName: "",
      PayScale: "",
      AgeLimit: "",
      UserId: UID,
    }));
  };

  const filteredItems = dataFilter.filter((item) =>
    item.PostName?.toLowerCase().includes(filterText.toLowerCase())||
  item.PayScale?.toLowerCase().includes(filterText.toLowerCase())||
  item.AgeLimit?.toLowerCase().includes(filterText.toLowerCase())
  );

  const subHeaderComponentMemo = useMemo(() => {
  
  }, [filterText, resetPaginationToggle]);


  useEffect(() => {
    const fetchProfitCenters = async () => {
      try {
        const response = await getProfitCenter(UID);
        const responses = await getDepartments(UID);

        setDepartment(responses.data.data);
        console.log(department, "dept");

        setProfitCenters(response.data.data);
        console.log(profitCenters, "pro");
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };

    fetchProfitCenters();
  }, []);
  
  useEffect(() => {
    setLoading(true);
    fetchJobOpenings();
  }, []);

  useEffect(() => {
    if (jobOpenings && jobOpenings.length > 0) {
      const updatedData = jobOpenings.map((item, index) => ({
        Slno: index + 1,
        Id: item.Id || "",
        PostName: item.PostName || "",
        PayScale: item.PayScale || "",
        AgeLimit: item.AgeLimit || "",
        UserId: UID || "",
      }));
      setDataFilter(updatedData);
    }else{
      setDataFilter([])
    }
  }, [jobOpenings]);



  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);  // Update state with the filtered data
  };

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible); // Toggle visibility when button is clicked
  };
  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };


  return (
    <>
         {isModalOpen && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              Are you sure you want to delete this Job opening?
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={confirmDelete}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
       <div className="flex items-center justify-between mb-8">
        <Breadcrumb title="Job Openings" />

        {/* Action Area */}
        <div className="flex items-center gap-4">
          {/* Search and Clear Buttons */}
          <div className="flex items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-10 py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Post"
                className="w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger"
            >
              Clear
            </button>
          </div>

          {/* Add New Button */}
          <button
            onClick={openAddJobOpeningModal}
            className="btn btn-primary"
          >
            Add New
          </button>
        </div>
      </div>


      {isFilterVisible && (
        <FilterComponent columns={columnsFilter} data={jobOpenings} onFilter={handleFilter} />
      )}
      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">

        <div className="react-data-table">
          <div className="react-data-table">
            {loading ? (
              <Loading />
            ) : (
              <ReactDataTable
                columns={columnsFilter}
                data={filteredItems}
                pagination
                paginationResetDefaultPage={resetPaginationToggle}
                subHeader
                subHeaderComponent={subHeaderComponentMemo}
              />
            )}
          </div>
        </div>
      </div>

{/* ===========================================Add================================== */}
      {addJobOpeningModal && (
        <>

        <form onSubmit={handleSubmit}>
          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
            <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Add Job Opening
                <span className="absolute top-0 right-0">
                  <button onClick={openAddJobOpeningModal} className="btn flex items-center justify-center">
                    ✖
                  </button>
                </span>
              </h5>
              <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                <div className="grid grid-cols-12 gap-20">
                  <div className="form-group flex col-span-12 flex-col gap-2 ">
                    <lable>
                      {" "}
                      Post Name <span style={{ color: "red" }}>*</span>{" "}
                    </lable>
                    <input
                      type="text"
                      id="name"
                      name="PostName"
                      placeholder="PostName"
                      value={jobOpeningData.PostName}
                      onChange={handleChange}
                      required
                      onBlur={(e) => {
                        handleChange({ target: { name: "PostName", value: e.target.value.trim() } });
                      }}
                    />
                  </div>
                  <div className="form-group flex col-span-12 flex-col gap-2 ">
                    <lable>
                      {" "}
                      Pay Scale <span style={{ color: "red" }}>*</span>{" "}
                    </lable>
                    <input
                      type="text"
                      id="PayScale"
                      name="PayScale"
                      placeholder="PayScale"
                      value={jobOpeningData.PayScale}
                      onChange={handleChange}
                      required
                      onBlur={(e) => {
                        handleChange({ target: { name: "PayScale", value: e.target.value.trim() } });
                      }}
                    />
                  </div>
                  <div className="form-group flex col-span-12 flex-col gap-2 ">
                    <lable>
                      {" "}
                      Age Limit <span style={{ color: "red" }}>*</span>{" "}
                    </lable>
                    <input
                      type="text"
                      id="AgeLimit"
                      name="AgeLimit"
                      placeholder="AgeLimit"
                      value={jobOpeningData.AgeLimit}
                      onChange={handleChange}
                      required
                      onBlur={(e) => {
                        handleChange({ target: { name: "AgeLimit", value: e.target.value.trim() } });
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                <button type="button"
                  onClick={clearData}
                  className="btn btn-outline-secondary"
                >
                  Clear
                </button>
                <button
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Add"}
                </button>
              </div>
            </div>
          </div>
          </form>
          <div
            // onClick={openAddJobOpeningModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}

      {/* ==========================================edit========================================== */}
      {editJobOpeningModal && (
        <>

        <form onSubmit={handleEdit}>
          <div className="fixed p-15 w-full max-w-[600px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
            <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                Edit Job Opening
                <span className="absolute top-0 right-0">
                  <button onClick={openEditJobOpeningModal} className="btn flex items-center justify-center">
                    ✖
                  </button>
                </span>
              </h5>
              <div className="my-10 md:px-10 px-[7px] max-h-[60vh] overflow-auto cus-scrollbar">
                <div className="grid grid-cols-12 gap-20">
                  <div className="form-group flex col-span-12"></div>
                  <div className="form-group flex col-span-12 flex-col gap-2">
                    <label>
                      Post Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      id="PostName"
                      name="PostName"
                      placeholder="PostName"
                      value={jobOpeningData.PostName}
                      onChange={handleChange}
                      required
                      onBlur={(e) => {
                        handleChange({ target: { name: "PostName", value: e.target.value.trim() } });
                      }}

                    />
                  </div>
                  <div className="form-group flex col-span-12 flex-col gap-2">
                    <label>
                      Pay Scale<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      id="PayScale"
                      name="PayScale"
                      placeholder="PayScale"
                      value={jobOpeningData.PayScale}
                      onChange={handleChange}
                      required
                      onBlur={(e) => {
                        handleChange({ target: { name: "PayScale", value: e.target.value.trim() } });
                      }}
                    />
                  </div>
                  <div className="form-group flex col-span-12 flex-col gap-2">
                    <label>
                      Age Limit <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      id="AgeLimit"
                      name="AgeLimit"
                      placeholder="AgeLimit"
                      value={jobOpeningData.AgeLimit}
                      onChange={handleChange}
                      required
                      onBlur={(e) => {
                        handleChange({ target: { name: "AgeLimit", value: e.target.value.trim() } });
                      }}
                    />
                      {error && <div style={{ color: "red", marginTop: "5px" }}>{error}</div>} 
                  </div>
                </div>
              </div>
              <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                <button
                  onClick={clearDataForEdit}
                  className="btn btn-outline-secondary"
                >
                  Clear
                </button>
                <button
                  className="btn btn-primary"
                  disabled={loading}
                >
                  {loading ? "Loading..." : "Edit"}
                </button>
              </div>
            </div>
          </div>
          </form>
          <div
            // onClick={openEditJobOpeningModal}
            className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"
          ></div>
        </>
      )}
    </>
  );
}
